<div class="offers-comparison-panel bottom-fixed-panel">
    <div class="offers-comparison-panel__offers">
        <ng-container *ngFor="let offer of offers; last as isLast">
            <app-offers-comparison-panel-offer [offer]="offer"
                                               (remove)="removeOfferFromComparison(offer)"
            ></app-offers-comparison-panel-offer>

            <div *ngIf="!isLast"
                 class="offers-comparison-panel__offers__divider"
            ></div>
        </ng-container>
    </div>

    <div class="offers-comparison-panel__buttons">
        <button class="btn btn--clear offers-comparison-panel__buttons__clear-btn"
                (click)="clearComparison()"
        >
            <img [src]="clearComparisonButtonIcon" alt="">
            {{ 'OFFERS_COMPARISON_PANEL.clearComparison' | translate }}
        </button>
        <button class="btn btn--blue offers-comparison-panel__buttons__compare-btn"
                (click)="compareOffers()"
        >
            {{ 'OFFERS_COMPARISON_PANEL.compare' | translate }}
        </button>
    </div>
</div>
